import { REFERENCES, REFERENCES_QUALIFICATION, TIER_LABELS } from '../data/references';
import {
  BUILD_GAP_STATEMENT,
  DISCLAIMER_FULL,
  RESEARCH_BASIS_STATEMENT,
  RESEARCH_PROVENANCE,
} from '../data/provenance';
import { Disclosure } from './Primitives';
import { trackEvent } from '../utils/analytics';

export function ReferencesPanel() {
  return (
    <div className="references">
      <p className="qualification">{REFERENCES_QUALIFICATION}</p>
      <ul className="reference-list">
        {REFERENCES.map((ref) => (
          <li key={ref.id} className="reference">
            <div className="reference-head">
              <span className="reference-designation">{ref.designation}</span>
              <span className="tier-tag">{TIER_LABELS[ref.tier]}</span>
            </div>
            <p className="reference-title">{ref.title}</p>
            <p className="reference-meta">
              {ref.publisher} · {ref.year}
            </p>
            <p className="reference-review">{ref.reviewStatus}</p>
            {ref.note && <p className="reference-note">{ref.note}</p>}
            {ref.url && (
              <a className="reference-link" href={ref.url} target="_blank" rel="noreferrer noopener">
                Publisher record
              </a>
            )}
          </li>
        ))}
      </ul>
      <p className="field-help">
        No clause text from any standard is reproduced in this application, in the interface or in the generated summary.
      </p>
    </div>
  );
}

export function ProvenancePanel() {
  return (
    <Disclosure summary="Research basis and provenance" onOpen={() => trackEvent('provenance_viewed')}>
      <p className="provenance-statement">{RESEARCH_BASIS_STATEMENT}</p>
      <p className="provenance-gap">{BUILD_GAP_STATEMENT}</p>
      <dl className="provenance-grid">
        {RESEARCH_PROVENANCE.map((entry) => (
          <div key={entry.label}>
            <dt>{entry.label}</dt>
            <dd>
              {entry.value}
              {entry.note && <span className="provenance-note">{entry.note}</span>}
            </dd>
          </div>
        ))}
      </dl>
    </Disclosure>
  );
}

export function DisclaimerBlock() {
  return (
    <div className="disclaimer" id="scope">
      <p className="disclaimer-eyebrow">Engineering scope boundary</p>
      {DISCLAIMER_FULL.map((paragraph, index) => (
        <p key={index} className={index === 0 ? 'disclaimer-lead' : 'disclaimer-body'}>
          {paragraph}
        </p>
      ))}
    </div>
  );
}
